import { ReceivedSamples, ReceivedSampleSerieStatus } from '../types/received-samples.types';
import { SamplesSequenced } from '../types/overview.types';
import { EditGoal, SequenceGoal } from '../components/CollectionAndSequencing/Overview/SequenceGoal/SequenceGoal.types';
import {
  AwaitingSamplesResponse,
  SampleTrackingResponse,
  SequencedSamplesOverview,
  KitFailureReasonResponse,
} from '../types';
import { groupDemographicsData } from '../utils';
import { SequencedSamples, SequencedSampleSerieStatus } from '../types/sequenced-samples.types';
import { SampleCollectionLocation, SampleSerieType } from '@modules/study-insights/types/samples.types';
import PartnerConsentedParticipantsData from '../components/ParticipantRecluitment/shared/types/PartnerConsentedParticipantData.types';
import { SingleValueBarFormat } from '@/common/components/builder/organisms/Charts';
import { ConsentStatus } from '../components/ParticipantRecluitment/Layouts/LayoutThree/ConsentStatus/ConsentStatus.types';
import { HhcParticipantData } from '../components/ParticipantRecluitment/shared/types/HhcParticipantData.types';

export const YEARLY_SEQUENCE_GOAL_DATA: SequenceGoal[] = [
  {
    target: 30000,
    value: 6000,
    startDate: '2022-10-01T00:00:00.000Z',
    endDate: '2023-10-01T00:00:00.000Z',
  },
  {
    target: 27000,
    value: 5000,
    startDate: '2023-10-01T00:00:00.000Z',
    endDate: '2024-10-01T00:00:00.000Z',
  },
  {
    target: 30000,
    value: 6000,
    startDate: '2024-10-01T00:00:00.000Z',
    endDate: '2025-10-01T00:00:00.000Z',
  },
  {
    target: 24000,
    value: 6000,
    startDate: '2025-10-01T00:00:00.000Z',
    endDate: '2026-10-01T00:00:00.000Z',
  },
];

export const FOUR_YEAR_SEQUENCE_GOAL_DATA: SequenceGoal = {
  target: 100000,
  value: 16000,
  startDate: '2022-10-01T00:00:00.000Z',
  endDate: '2023-10-01T00:00:00.000Z',
};

export const MOCK_DATA_STACKED_BAR: SamplesSequenced = {
  twelveMonthsTotal: {
    total: 52000,
    groupKey: 'BY_MONTH',
    series: [
      {
        status: 'VALID',
        groupValue: '2022-02-28T16:00:00-08:00',
        value: 217,
      },
      {
        status: 'VALID',
        groupValue: '2022-03-31T17:00:00-07:00',
        value: 454,
      },
      {
        status: 'VALID',
        groupValue: '2022-04-30T17:00:00-07:00',
        value: 673,
      },
      {
        status: 'VALID',
        groupValue: '2022-05-31T17:00:00-07:00',
        value: 412,
      },
      {
        status: 'VALID',
        groupValue: '2022-06-30T17:00:00-07:00',
        value: 1119,
      },
      {
        status: 'VALID',
        groupValue: '2022-07-31T17:00:00-07:00',
        value: 1136,
      },
      {
        status: 'VALID',
        groupValue: '2022-08-31T17:00:00-07:00',
        value: 1163,
      },
      {
        status: 'VALID',
        groupValue: '2022-09-30T17:00:00-07:00',
        value: 2011,
      },
      {
        status: 'VALID',
        groupValue: '2022-10-31T17:00:00-07:00',
        value: 772,
      },
      {
        status: 'VALID',
        groupValue: '2022-11-30T16:00:00-08:00',
        value: 2549,
      },
      {
        status: 'VALID',
        groupValue: '2022-12-31T16:00:00-08:00',
        value: 1238,
      },
      {
        status: 'VALID',
        groupValue: '2023-01-31T16:00:00-08:00',
        value: 495,
      },
    ],
  },
  metric: {
    total: 52000,
    groupKey: 'BY_MONTH',
    series: [
      {
        status: 'VALID',
        groupValue: '2022-02-28T16:00:00-08:00',
        value: 217,
      },
      {
        status: 'VALID',
        groupValue: '2022-03-31T17:00:00-07:00',
        value: 454,
      },
      {
        status: 'VALID',
        groupValue: '2022-04-30T17:00:00-07:00',
        value: 673,
      },
      {
        status: 'VALID',
        groupValue: '2022-05-31T17:00:00-07:00',
        value: 412,
      },
      {
        status: 'VALID',
        groupValue: '2022-06-30T17:00:00-07:00',
        value: 1119,
      },
      {
        status: 'VALID',
        groupValue: '2022-07-31T17:00:00-07:00',
        value: 1136,
      },
      {
        status: 'VALID',
        groupValue: '2022-08-31T17:00:00-07:00',
        value: 1163,
      },
      {
        status: 'VALID',
        groupValue: '2022-09-30T17:00:00-07:00',
        value: 2011,
      },
      {
        status: 'VALID',
        groupValue: '2022-10-31T17:00:00-07:00',
        value: 772,
      },
      {
        status: 'VALID',
        groupValue: '2022-11-30T16:00:00-08:00',
        value: 2549,
      },
      {
        status: 'VALID',
        groupValue: '2022-12-31T16:00:00-08:00',
        value: 1238,
      },
      {
        status: 'VALID',
        groupValue: '2023-01-31T16:00:00-08:00',
        value: 495,
      },
    ],
  },
};

export const MOCK_EMPTY_SEQUENCING_DATA = {
  stats: {
    percentChanges: [],
  },
  series: [],
};

export const MOCK_AWAITING_SAMPLE: AwaitingSamplesResponse[] = [
  {
    collectionLocation: SampleCollectionLocation.IN_PERSON,
    value: 129,
  },
  {
    collectionLocation: SampleCollectionLocation.AT_HOME,
    value: 72,
  },
];

export const MOCK_DEMOGRAPHICS: any = {
  byRaceEthnicity: [
    {
      groupValue: 'AMERICAN INDIAN OR ALASKA NATIVE',
      value: 139,
      collectionLocation: 'IN_PERSON',
      status: 'RECEIVED',
      type: 'BLOOD',
    },
    {
      groupValue: 'AMERICAN INDIAN OR ALASKA NATIVE',
      value: 48,
      collectionLocation: 'IN_PERSON',
      status: 'RECEIVED',
      type: 'SALIVA',
    },
    {
      groupValue: 'AMERICAN INDIAN OR ALASKA NATIVE',
      value: 62,
      collectionLocation: 'AT_HOME',
      status: 'RECEIVED',
      type: 'BLOOD',
    },
    {
      groupValue: 'AMERICAN INDIAN OR ALASKA NATIVE',
      value: 215,
      collectionLocation: 'AT_HOME',
      status: 'RECEIVED',
      type: 'SALIVA',
    },
    {
      groupValue: 'ASIAN',
      value: 99,
      collectionLocation: 'IN_PERSON',
      status: 'RECEIVED',
      type: 'BLOOD',
    },
    {
      groupValue: 'ASIAN',
      value: 7,
      collectionLocation: 'IN_PERSON',
      status: 'RECEIVED',
      type: 'SALIVA',
    },
    {
      groupValue: 'ASIAN',
      value: 100,
      collectionLocation: 'AT_HOME',
      status: 'RECEIVED',
      type: 'BLOOD',
    },
    {
      groupValue: 'ASIAN',
      value: 39,
      collectionLocation: 'AT_HOME',
      status: 'RECEIVED',
      type: 'SALIVA',
    },
    {
      groupValue: 'BLACK OR AFRICAN AMERICAN',
      value: 32,
      collectionLocation: 'IN_PERSON',
      status: 'RECEIVED',
      type: 'BLOOD',
    },
    {
      groupValue: 'BLACK OR AFRICAN AMERICAN',
      value: 80,
      collectionLocation: 'IN_PERSON',
      status: 'RECEIVED',
      type: 'SALIVA',
    },
    {
      groupValue: 'BLACK OR AFRICAN AMERICAN',
      value: 82,
      collectionLocation: 'AT_HOME',
      status: 'RECEIVED',
      type: 'BLOOD',
    },
    {
      groupValue: 'BLACK OR AFRICAN AMERICAN',
      value: 11,
      collectionLocation: 'AT_HOME',
      status: 'RECEIVED',
      type: 'SALIVA',
    },
    {
      groupValue: 'OTHER',
      value: 178,
      collectionLocation: 'IN_PERSON',
      status: 'RECEIVED',
      type: 'BLOOD',
    },
    {
      groupValue: 'OTHER',
      value: 53,
      collectionLocation: 'IN_PERSON',
      status: 'RECEIVED',
      type: 'SALIVA',
    },
    {
      groupValue: 'OTHER',
      value: 11,
      collectionLocation: 'AT_HOME',
      status: 'RECEIVED',
      type: 'BLOOD',
    },
    {
      groupValue: 'OTHER',
      value: 66,
      collectionLocation: 'AT_HOME',
      status: 'RECEIVED',
      type: 'SALIVA',
    },
    {
      groupValue: 'WHITE',
      value: 33,
      collectionLocation: 'IN_PERSON',
      status: 'RECEIVED',
      type: 'BLOOD',
    },
    {
      groupValue: 'WHITE',
      value: 6,
      collectionLocation: 'IN_PERSON',
      status: 'RECEIVED',
      type: 'SALIVA',
    },
    {
      groupValue: 'WHITE',
      value: 88,
      collectionLocation: 'AT_HOME',
      status: 'RECEIVED',
      type: 'BLOOD',
    },
    {
      groupValue: 'WHITE',
      value: 1,
      collectionLocation: 'AT_HOME',
      status: 'RECEIVED',
      type: 'SALIVA',
    },
  ],
  byPreferredLanguage: [
    {
      groupValue: 'CHINESE',
      value: 46,
      collectionLocation: 'IN_PERSON',
      status: 'RECEIVED',
      type: 'BLOOD',
    },
    {
      groupValue: 'CHINESE',
      value: 69,
      collectionLocation: 'IN_PERSON',
      status: 'RECEIVED',
      type: 'SALIVA',
    },
    {
      groupValue: 'CHINESE',
      value: 107,
      collectionLocation: 'AT_HOME',
      status: 'RECEIVED',
      type: 'BLOOD',
    },
    {
      groupValue: 'CHINESE',
      value: 10,
      collectionLocation: 'AT_HOME',
      status: 'RECEIVED',
      type: 'SALIVA',
    },
    {
      groupValue: 'ENGLISH',
      value: 69,
      collectionLocation: 'IN_PERSON',
      status: 'RECEIVED',
      type: 'BLOOD',
    },
    {
      groupValue: 'ENGLISH',
      value: 162,
      collectionLocation: 'IN_PERSON',
      status: 'RECEIVED',
      type: 'SALIVA',
    },
    {
      groupValue: 'ENGLISH',
      value: 60,
      collectionLocation: 'AT_HOME',
      status: 'RECEIVED',
      type: 'BLOOD',
    },
    {
      groupValue: 'ENGLISH',
      value: 87,
      collectionLocation: 'AT_HOME',
      status: 'RECEIVED',
      type: 'SALIVA',
    },
    {
      groupValue: 'OTHER',
      value: 33,
      collectionLocation: 'IN_PERSON',
      status: 'RECEIVED',
      type: 'BLOOD',
    },
    {
      groupValue: 'OTHER',
      value: 38,
      collectionLocation: 'IN_PERSON',
      status: 'RECEIVED',
      type: 'SALIVA',
    },
    {
      groupValue: 'OTHER',
      value: 145,
      collectionLocation: 'AT_HOME',
      status: 'RECEIVED',
      type: 'BLOOD',
    },
    {
      groupValue: 'OTHER',
      value: 59,
      collectionLocation: 'AT_HOME',
      status: 'RECEIVED',
      type: 'SALIVA',
    },
    {
      groupValue: 'SPANISH',
      value: 119,
      collectionLocation: 'IN_PERSON',
      status: 'RECEIVED',
      type: 'BLOOD',
    },
    {
      groupValue: 'SPANISH',
      value: 27,
      collectionLocation: 'IN_PERSON',
      status: 'RECEIVED',
      type: 'SALIVA',
    },
    {
      groupValue: 'SPANISH',
      value: 246,
      collectionLocation: 'AT_HOME',
      status: 'RECEIVED',
      type: 'BLOOD',
    },
    {
      groupValue: 'SPANISH',
      value: 73,
      collectionLocation: 'AT_HOME',
      status: 'RECEIVED',
      type: 'SALIVA',
    },
  ],
  byAgeRange: [
    {
      groupValue: '-17',
      value: 60,
      collectionLocation: 'IN_PERSON',
      status: 'RECEIVED',
      type: 'BLOOD',
    },
    {
      groupValue: '-17',
      value: 13,
      collectionLocation: 'IN_PERSON',
      status: 'RECEIVED',
      type: 'SALIVA',
    },
    {
      groupValue: '-17',
      value: 198,
      collectionLocation: 'AT_HOME',
      status: 'RECEIVED',
      type: 'BLOOD',
    },
    {
      groupValue: '-17',
      value: 66,
      collectionLocation: 'AT_HOME',
      status: 'RECEIVED',
      type: 'SALIVA',
    },
    {
      groupValue: '18-24',
      value: 24,
      collectionLocation: 'IN_PERSON',
      status: 'RECEIVED',
      type: 'BLOOD',
    },
    {
      groupValue: '18-24',
      value: 46,
      collectionLocation: 'IN_PERSON',
      status: 'RECEIVED',
      type: 'SALIVA',
    },
    {
      groupValue: '18-24',
      value: 8,
      collectionLocation: 'AT_HOME',
      status: 'RECEIVED',
      type: 'BLOOD',
    },
    {
      groupValue: '18-24',
      value: 1,
      collectionLocation: 'AT_HOME',
      status: 'RECEIVED',
      type: 'SALIVA',
    },
    {
      groupValue: '25-35',
      value: 26,
      collectionLocation: 'IN_PERSON',
      status: 'RECEIVED',
      type: 'BLOOD',
    },
    {
      groupValue: '25-35',
      value: 8,
      collectionLocation: 'IN_PERSON',
      status: 'RECEIVED',
      type: 'SALIVA',
    },
    {
      groupValue: '25-35',
      value: 82,
      collectionLocation: 'AT_HOME',
      status: 'RECEIVED',
      type: 'BLOOD',
    },
    {
      groupValue: '25-35',
      value: 56,
      collectionLocation: 'AT_HOME',
      status: 'RECEIVED',
      type: 'SALIVA',
    },
    {
      groupValue: '36-44',
      value: 9,
      collectionLocation: 'IN_PERSON',
      status: 'RECEIVED',
      type: 'BLOOD',
    },
    {
      groupValue: '36-44',
      value: 49,
      collectionLocation: 'IN_PERSON',
      status: 'RECEIVED',
      type: 'SALIVA',
    },
    {
      groupValue: '36-44',
      value: 35,
      collectionLocation: 'AT_HOME',
      status: 'RECEIVED',
      type: 'BLOOD',
    },
    {
      groupValue: '36-44',
      value: 122,
      collectionLocation: 'AT_HOME',
      status: 'RECEIVED',
      type: 'SALIVA',
    },
    {
      groupValue: '45-55',
      value: 31,
      collectionLocation: 'IN_PERSON',
      status: 'RECEIVED',
      type: 'BLOOD',
    },
    {
      groupValue: '45-55',
      value: 35,
      collectionLocation: 'IN_PERSON',
      status: 'RECEIVED',
      type: 'SALIVA',
    },
    {
      groupValue: '45-55',
      value: 13,
      collectionLocation: 'AT_HOME',
      status: 'RECEIVED',
      type: 'BLOOD',
    },
    {
      groupValue: '45-55',
      value: 19,
      collectionLocation: 'AT_HOME',
      status: 'RECEIVED',
      type: 'SALIVA',
    },
    {
      groupValue: '56-64',
      value: 1,
      collectionLocation: 'IN_PERSON',
      status: 'RECEIVED',
      type: 'BLOOD',
    },
    {
      groupValue: '56-64',
      value: 116,
      collectionLocation: 'IN_PERSON',
      status: 'RECEIVED',
      type: 'SALIVA',
    },
    {
      groupValue: '56-64',
      value: 16,
      collectionLocation: 'AT_HOME',
      status: 'RECEIVED',
      type: 'BLOOD',
    },
    {
      groupValue: '56-64',
      value: 11,
      collectionLocation: 'AT_HOME',
      status: 'RECEIVED',
      type: 'SALIVA',
    },
    {
      groupValue: '65-75',
      value: 13,
      collectionLocation: 'IN_PERSON',
      status: 'RECEIVED',
      type: 'BLOOD',
    },
    {
      groupValue: '65-75',
      value: 62,
      collectionLocation: 'IN_PERSON',
      status: 'RECEIVED',
      type: 'SALIVA',
    },
    {
      groupValue: '65-75',
      value: 108,
      collectionLocation: 'AT_HOME',
      status: 'RECEIVED',
      type: 'BLOOD',
    },
    {
      groupValue: '65-75',
      value: 7,
      collectionLocation: 'AT_HOME',
      status: 'RECEIVED',
      type: 'SALIVA',
    },
    {
      groupValue: '76-',
      value: 11,
      collectionLocation: 'IN_PERSON',
      status: 'RECEIVED',
      type: 'BLOOD',
    },
    {
      groupValue: '76-',
      value: 21,
      collectionLocation: 'IN_PERSON',
      status: 'RECEIVED',
      type: 'SALIVA',
    },
    {
      groupValue: '76-',
      value: 71,
      collectionLocation: 'AT_HOME',
      status: 'RECEIVED',
      type: 'BLOOD',
    },
    {
      groupValue: '76-',
      value: 12,
      collectionLocation: 'AT_HOME',
      status: 'RECEIVED',
      type: 'SALIVA',
    },
  ],
  byBiologicalSex: [
    {
      groupValue: 'FEMALE',
      value: 142,
      collectionLocation: 'IN_PERSON',
      status: 'RECEIVED',
      type: 'BLOOD',
    },
    {
      groupValue: 'FEMALE',
      value: 31,
      collectionLocation: 'IN_PERSON',
      status: 'RECEIVED',
      type: 'SALIVA',
    },
    {
      groupValue: 'FEMALE',
      value: 79,
      collectionLocation: 'AT_HOME',
      status: 'RECEIVED',
      type: 'BLOOD',
    },
    {
      groupValue: 'FEMALE',
      value: 6,
      collectionLocation: 'AT_HOME',
      status: 'RECEIVED',
      type: 'SALIVA',
    },
    {
      groupValue: 'MALE',
      value: 304,
      collectionLocation: 'IN_PERSON',
      status: 'RECEIVED',
      type: 'BLOOD',
    },
    {
      groupValue: 'MALE',
      value: 195,
      collectionLocation: 'IN_PERSON',
      status: 'RECEIVED',
      type: 'SALIVA',
    },
    {
      groupValue: 'MALE',
      value: 66,
      collectionLocation: 'AT_HOME',
      status: 'RECEIVED',
      type: 'BLOOD',
    },
    {
      groupValue: 'MALE',
      value: 15,
      collectionLocation: 'AT_HOME',
      status: 'RECEIVED',
      type: 'SALIVA',
    },
    {
      groupValue: 'NONBINARY',
      value: 29,
      collectionLocation: 'IN_PERSON',
      status: 'RECEIVED',
      type: 'BLOOD',
    },
    {
      groupValue: 'NONBINARY',
      value: 12,
      collectionLocation: 'IN_PERSON',
      status: 'RECEIVED',
      type: 'SALIVA',
    },
    {
      groupValue: 'NONBINARY',
      value: 61,
      collectionLocation: 'AT_HOME',
      status: 'RECEIVED',
      type: 'BLOOD',
    },
    {
      groupValue: 'NONBINARY',
      value: 49,
      collectionLocation: 'AT_HOME',
      status: 'RECEIVED',
      type: 'SALIVA',
    },
    {
      groupValue: 'OTHER',
      value: 21,
      collectionLocation: 'IN_PERSON',
      status: 'RECEIVED',
      type: 'BLOOD',
    },
    {
      groupValue: 'OTHER',
      value: 75,
      collectionLocation: 'IN_PERSON',
      status: 'RECEIVED',
      type: 'SALIVA',
    },
    {
      groupValue: 'OTHER',
      value: 156,
      collectionLocation: 'AT_HOME',
      status: 'RECEIVED',
      type: 'BLOOD',
    },
    {
      groupValue: 'OTHER',
      value: 109,
      collectionLocation: 'AT_HOME',
      status: 'RECEIVED',
      type: 'SALIVA',
    },
  ],
};

export const MOCK_GROUPED_DEMOGRAPHICS_DATA = {
  byRaceEthnicity: groupDemographicsData(MOCK_DEMOGRAPHICS.byRaceEthnicity),
  byPreferredLanguage: groupDemographicsData(MOCK_DEMOGRAPHICS.byPreferredLanguage),
  byAgeRange: groupDemographicsData(MOCK_DEMOGRAPHICS.byAgeRange),
  byBiologicalSex: groupDemographicsData(MOCK_DEMOGRAPHICS.byBiologicalSex),
};

export const MOCK_TEST_DEMOGRAPHICS = {
  byRaceEthnicity: [
    {
      collectionLocation: 'AT_HOME',
      status: 'VALID',
      type: 'SALIVA',
      groupValue: 'WHITE',
      value: 10,
    },
    {
      collectionLocation: 'IN_PERSON',
      status: 'RECOLLECT',
      type: 'BLOOD',
      groupValue: 'ASIAN',
      value: 5,
    },
    {
      collectionLocation: 'IN_PERSON',
      status: 'RECOLLECT',
      type: 'BLOOD',
      groupValue: 'ASIAN',
      value: 5,
    },
  ],
  byPreferredLanguage: [
    {
      collectionLocation: 'AT_HOME',
      status: 'VALID',
      type: 'SALIVA',
      groupValue: 'SPANISH',
      value: 10,
    },
    {
      collectionLocation: 'IN_PERSON',
      status: 'RECOLLECT',
      type: 'BLOOD',
      groupValue: 'ENGLISH',
      value: 10,
    },
  ],
  byAgeRange: [
    {
      collectionLocation: 'IN_PERSON',
      status: 'RECOLLECT',
      type: 'BLOOD',
      groupValue: '45-55',
      value: 10,
    },
    {
      collectionLocation: 'AT_HOME',
      status: 'RECOLLECT',
      type: 'SALIVA',
      groupValue: '25-35',
      value: 10,
    },
  ],
  byBiologicalSex: [
    {
      collectionLocation: 'AT_HOME',
      status: 'VALID',
      type: 'SALIVA',
      groupValue: 'FEMALE',
      value: 10,
    },
    {
      collectionLocation: 'IN_PERSON',
      status: 'VALID',
      type: 'BLOOD',
      groupValue: 'MALE',
      value: 10,
    },
  ],
};

export const MOCK_SEQUENCED_SAMPLES_OVERVIEW: SequencedSamplesOverview = {
  ...MOCK_DATA_STACKED_BAR,
  goals: {
    yearly: YEARLY_SEQUENCE_GOAL_DATA,
    fourYear: FOUR_YEAR_SEQUENCE_GOAL_DATA,
  },
};

export const MOCK_SAMPLE_TRACKING: SampleTrackingResponse | any = {
  meta: {
    totalCount: 31,
  },
  data: [
    {
      statusDate: '2022-04-01T00:00:00Z',
      orderId: '12345',
      status: 'RECEIVED',
      sampleType: 'BLOOD',
    },
    {
      statusDate: '2022-04-01T00:00:00Z',
      orderId: '123456',
      status: 'RECEIVED',
      sampleType: 'SALIVA',
    },
    {
      statusDate: '2022-04-01T00:00:00Z',
      orderId: '123457',
      status: 'IN_SEQUENCING',
      sampleType: 'SALIVA',
    },
    {
      statusDate: '2022-04-02T00:00:00Z',
      orderId: '123458',
      status: 'VALID',
      sampleType: 'BLOOD',
    },
    {
      statusDate: '2022-04-02T00:00:00Z',
      orderId: '123459',
      status: 'VALID',
      sampleType: 'SALIVA',
    },
    {
      statusDate: '2022-04-03T00:00:00Z',
      orderId: '123460',
      status: 'RECOLLECT',
      sampleType: 'BLOOD',
      failureReason: 'Failure Reason Example',
    },
    {
      statusDate: '2022-04-03T00:00:00Z',
      orderId: '123461',
      status: 'AWAITING',
      sampleType: 'BLOOD',
    },
    {
      statusDate: '2022-04-03T00:00:00Z',
      orderId: '123462',
      status: 'AWAITING',
      sampleType: 'BLOOD',
    },
    {
      statusDate: '2022-04-04T00:00:00Z',
      orderId: '123463',
      status: 'VALID',
      sampleType: 'BLOOD',
    },
    {
      statusDate: '2022-04-04T00:00:00Z',
      orderId: '123464',
      status: 'VALID',
      sampleType: 'BLOOD',
    },
    {
      statusDate: '2022-04-05T00:00:00Z',
      orderId: '123465',
      status: 'RECOLLECT',
      sampleType: 'BLOOD',
      failureReason: 'Failure Reason Example',
    },
    {
      statusDate: '2022-04-10T00:00:00Z',
      orderId: '123466',
      status: 'IN_SEQUENCING',
      sampleType: 'BLOOD',
    },
    {
      statusDate: '2022-04-10T00:00:00Z',
      orderId: '123467',
      status: 'IN_SEQUENCING',
      sampleType: 'BLOOD',
    },
    {
      statusDate: '2022-04-10T00:00:00Z',
      orderId: '123468',
      status: 'IN_SEQUENCING',
      sampleType: 'SALIVA',
    },
    {
      statusDate: '2022-04-10T00:00:00Z',
      orderId: '123469',
      status: 'IN_SEQUENCING',
      sampleType: 'BLOOD',
    },
    {
      statusDate: '2022-04-01T00:00:00Z',
      orderId: '123470',
      status: 'RECEIVED',
      sampleType: 'BLOOD',
    },
    {
      statusDate: '2022-04-01T00:00:00Z',
      orderId: '123471',
      status: 'RECEIVED',
      sampleType: 'SALIVA',
    },
    {
      statusDate: '2022-04-01T00:00:00Z',
      orderId: '123472',
      status: 'IN_SEQUENCING',
      sampleType: 'SALIVA',
    },
    {
      statusDate: '2022-04-02T00:00:00Z',
      orderId: '123473',
      status: 'VALID',
      sampleType: 'BLOOD',
    },
    {
      statusDate: '2022-04-02T00:00:00Z',
      orderId: '123474',
      status: 'VALID',
      sampleType: 'SALIVA',
    },
    {
      statusDate: '2022-04-03T00:00:00Z',
      orderId: '123475',
      status: 'RECOLLECT',
      sampleType: 'BLOOD',
      failureReason: 'Failure Reason Example',
    },
    {
      statusDate: '2022-04-03T00:00:00Z',
      orderId: '123476',
      status: 'AWAITING',
      sampleType: 'BLOOD',
    },
    {
      statusDate: '2022-04-03T00:00:00Z',
      orderId: '123477',
      status: 'AWAITING',
      sampleType: 'BLOOD',
    },
    {
      statusDate: '2022-04-04T00:00:00Z',
      orderId: '123478',
      status: 'VALID',
      sampleType: 'BLOOD',
    },
    {
      statusDate: '2022-04-04T00:00:00Z',
      orderId: '123479',
      status: 'VALID',
      sampleType: 'BLOOD',
    },
    {
      statusDate: '2022-04-05T00:00:00Z',
      orderId: '123480',
      status: 'RECOLLECT',
      sampleType: 'BLOOD',
      failureReason: 'Failure Reason Example',
    },
    {
      statusDate: '2022-04-10T00:00:00Z',
      orderId: '123481',
      status: 'IN_SEQUENCING',
      sampleType: 'BLOOD',
    },
    {
      statusDate: '2022-04-10T00:00:00Z',
      orderId: '123482',
      status: 'IN_SEQUENCING',
      sampleType: 'BLOOD',
    },
    {
      statusDate: '2022-04-10T00:00:00Z',
      orderId: '123483',
      status: 'IN_SEQUENCING',
      sampleType: 'SALIVA',
    },
    {
      statusDate: '2022-04-10T00:00:00Z',
      orderId: '123484',
      status: 'IN_SEQUENCING',
      sampleType: 'BLOOD',
    },
  ],
};

export const MOCK_SAMPLE_TRACKING_LOADER: SampleTrackingResponse | any = {
  meta: {
    hasMorePages: true,
  },
  data: [
    {
      statusDate: '2022-04-01T00:00:00Z',
      orderId: '12345',
      status: 'RECEIVED',
      sampleType: 'BLOOD',
    },
    {
      statusDate: '2022-04-01T00:00:00Z',
      orderId: '123456',
      status: 'RECEIVED',
      sampleType: 'SALIVA',
    },
    {
      statusDate: '2022-04-01T00:00:00Z',
      orderId: '123457',
      status: 'IN_SEQUENCING',
      sampleType: 'SALIVA',
    },
    {
      statusDate: '2022-04-02T00:00:00Z',
      orderId: '123458',
      status: 'VALID',
      sampleType: 'BLOOD',
    },
    {
      statusDate: '2022-04-02T00:00:00Z',
      orderId: '123459',
      status: 'VALID',
      sampleType: 'SALIVA',
    },
    {
      statusDate: '2022-04-03T00:00:00Z',
      orderId: '123460',
      status: 'RECOLLECT',
      sampleType: 'BLOOD',
      failureReason: 'Failure Reason Example',
    },
    {
      statusDate: '2022-04-03T00:00:00Z',
      orderId: '123461',
      status: 'AWAITING',
      sampleType: 'BLOOD',
    },
    {
      statusDate: '2022-04-03T00:00:00Z',
      orderId: '123462',
      status: 'AWAITING',
      sampleType: 'BLOOD',
    },
    {
      statusDate: '2022-04-04T00:00:00Z',
      orderId: '123463',
      status: 'VALID',
      sampleType: 'BLOOD',
    },
    {
      statusDate: '2022-04-04T00:00:00Z',
      orderId: '123464',
      status: 'VALID',
      sampleType: 'BLOOD',
    },
    {
      statusDate: '2022-04-05T00:00:00Z',
      orderId: '123465',
      status: 'RECOLLECT',
      sampleType: 'BLOOD',
      failureReason: 'Failure Reason Example',
    },
    {
      statusDate: '2022-04-10T00:00:00Z',
      orderId: '123466',
      status: 'IN_SEQUENCING',
      sampleType: 'BLOOD',
    },
    {
      statusDate: '2022-04-10T00:00:00Z',
      orderId: '123467',
      status: 'IN_SEQUENCING',
      sampleType: 'BLOOD',
    },
    {
      statusDate: '2022-04-10T00:00:00Z',
      orderId: '123468',
      status: 'IN_SEQUENCING',
      sampleType: 'SALIVA',
    },
    {
      statusDate: '2022-04-10T00:00:00Z',
      orderId: '123469',
      status: 'IN_SEQUENCING',
      sampleType: 'BLOOD',
    },
    {
      statusDate: '2022-04-01T00:00:00Z',
      orderId: '123470',
      status: 'RECEIVED',
      sampleType: 'BLOOD',
    },
    {
      statusDate: '2022-04-01T00:00:00Z',
      orderId: '123471',
      status: 'RECEIVED',
      sampleType: 'SALIVA',
    },
    {
      statusDate: '2022-04-01T00:00:00Z',
      orderId: '123472',
      status: 'IN_SEQUENCING',
      sampleType: 'SALIVA',
    },
    {
      statusDate: '2022-04-02T00:00:00Z',
      orderId: '123473',
      status: 'VALID',
      sampleType: 'BLOOD',
    },
    {
      statusDate: '2022-04-02T00:00:00Z',
      orderId: '123474',
      status: 'VALID',
      sampleType: 'SALIVA',
    },
    {
      statusDate: '2022-04-03T00:00:00Z',
      orderId: '123475',
      status: 'RECOLLECT',
      sampleType: 'BLOOD',
      failureReason: 'Failure Reason Example',
    },
    {
      statusDate: '2022-04-03T00:00:00Z',
      orderId: '123476',
      status: 'AWAITING',
      sampleType: 'BLOOD',
    },
    {
      statusDate: '2022-04-03T00:00:00Z',
      orderId: '123477',
      status: 'AWAITING',
      sampleType: 'BLOOD',
    },
    {
      statusDate: '2022-04-04T00:00:00Z',
      orderId: '123478',
      status: 'VALID',
      sampleType: 'BLOOD',
    },
    {
      statusDate: '2022-04-04T00:00:00Z',
      orderId: '123479',
      status: 'VALID',
      sampleType: 'BLOOD',
    },
    {
      statusDate: '2022-04-05T00:00:00Z',
      orderId: '123480',
      status: 'RECOLLECT',
      sampleType: 'BLOOD',
      failureReason: 'Failure Reason Example',
    },
    {
      statusDate: '2022-04-10T00:00:00Z',
      orderId: '123481',
      status: 'IN_SEQUENCING',
      sampleType: 'BLOOD',
    },
    {
      statusDate: '2022-04-10T00:00:00Z',
      orderId: '123482',
      status: 'IN_SEQUENCING',
      sampleType: 'BLOOD',
    },
    {
      statusDate: '2022-04-10T00:00:00Z',
      orderId: '123483',
      status: 'IN_SEQUENCING',
      sampleType: 'SALIVA',
    },
    {
      statusDate: '2022-04-10T00:00:00Z',
      orderId: '123484',
      status: 'IN_SEQUENCING',
      sampleType: 'BLOOD',
    },
  ],
};

export const MOCK_SAMPLE_TRACKING_HAS_MORE_PAGES: SampleTrackingResponse | any = {
  meta: {
    hasMorePages: true,
  },
  data: [
    {
      statusDate: '2022-04-01T00:00:00Z',
      orderId: '12345',
      status: 'RECEIVED',
      sampleType: 'BLOOD',
    },
    {
      statusDate: '2022-04-01T00:00:00Z',
      orderId: '123456',
      status: 'RECEIVED',
      sampleType: 'SALIVA',
    },
    {
      statusDate: '2022-04-01T00:00:00Z',
      orderId: '123457',
      status: 'IN_SEQUENCING',
      sampleType: 'SALIVA',
    },
    {
      statusDate: '2022-04-02T00:00:00Z',
      orderId: '123458',
      status: 'VALID',
      sampleType: 'BLOOD',
    },
    {
      statusDate: '2022-04-02T00:00:00Z',
      orderId: '123459',
      status: 'VALID',
      sampleType: 'SALIVA',
    },
    {
      statusDate: '2022-04-03T00:00:00Z',
      orderId: '123460',
      status: 'RECOLLECT',
      sampleType: 'BLOOD',
      failureReason: 'Failure Reason Example',
    },
    {
      statusDate: '2022-04-03T00:00:00Z',
      orderId: '123461',
      status: 'AWAITING',
      sampleType: 'BLOOD',
    },
    {
      statusDate: '2022-04-03T00:00:00Z',
      orderId: '123462',
      status: 'AWAITING',
      sampleType: 'BLOOD',
    },
    {
      statusDate: '2022-04-04T00:00:00Z',
      orderId: '123463',
      status: 'VALID',
      sampleType: 'BLOOD',
    },
    {
      statusDate: '2022-04-04T00:00:00Z',
      orderId: '123464',
      status: 'VALID',
      sampleType: 'BLOOD',
    },
    {
      statusDate: '2022-04-05T00:00:00Z',
      orderId: '123465',
      status: 'RECOLLECT',
      sampleType: 'BLOOD',
      failureReason: 'Failure Reason Example',
    },
    {
      statusDate: '2022-04-10T00:00:00Z',
      orderId: '123466',
      status: 'IN_SEQUENCING',
      sampleType: 'BLOOD',
    },
    {
      statusDate: '2022-04-10T00:00:00Z',
      orderId: '123467',
      status: 'IN_SEQUENCING',
      sampleType: 'BLOOD',
    },
    {
      statusDate: '2022-04-10T00:00:00Z',
      orderId: '123468',
      status: 'IN_SEQUENCING',
      sampleType: 'SALIVA',
    },
    {
      statusDate: '2022-04-10T00:00:00Z',
      orderId: '123469',
      status: 'IN_SEQUENCING',
      sampleType: 'BLOOD',
    },
    {
      statusDate: '2022-04-01T00:00:00Z',
      orderId: '123470',
      status: 'RECEIVED',
      sampleType: 'BLOOD',
    },
    {
      statusDate: '2022-04-01T00:00:00Z',
      orderId: '123471',
      status: 'RECEIVED',
      sampleType: 'SALIVA',
    },
    {
      statusDate: '2022-04-01T00:00:00Z',
      orderId: '123472',
      status: 'IN_SEQUENCING',
      sampleType: 'SALIVA',
    },
    {
      statusDate: '2022-04-02T00:00:00Z',
      orderId: '123473',
      status: 'VALID',
      sampleType: 'BLOOD',
    },
    {
      statusDate: '2022-04-02T00:00:00Z',
      orderId: '123474',
      status: 'VALID',
      sampleType: 'SALIVA',
    },
    {
      statusDate: '2022-04-03T00:00:00Z',
      orderId: '123475',
      status: 'RECOLLECT',
      sampleType: 'BLOOD',
      failureReason: 'Failure Reason Example',
    },
    {
      statusDate: '2022-04-03T00:00:00Z',
      orderId: '123476',
      status: 'AWAITING',
      sampleType: 'BLOOD',
    },
    {
      statusDate: '2022-04-03T00:00:00Z',
      orderId: '123477',
      status: 'AWAITING',
      sampleType: 'BLOOD',
    },
    {
      statusDate: '2022-04-04T00:00:00Z',
      orderId: '123478',
      status: 'VALID',
      sampleType: 'BLOOD',
    },
    {
      statusDate: '2022-04-04T00:00:00Z',
      orderId: '123479',
      status: 'VALID',
      sampleType: 'BLOOD',
    },
    {
      statusDate: '2022-04-05T00:00:00Z',
      orderId: '123480',
      status: 'RECOLLECT',
      sampleType: 'BLOOD',
      failureReason: 'Failure Reason Example',
    },
    {
      statusDate: '2022-04-10T00:00:00Z',
      orderId: '123481',
      status: 'IN_SEQUENCING',
      sampleType: 'BLOOD',
    },
    {
      statusDate: '2022-04-10T00:00:00Z',
      orderId: '123482',
      status: 'IN_SEQUENCING',
      sampleType: 'BLOOD',
    },
    {
      statusDate: '2022-04-10T00:00:00Z',
      orderId: '123483',
      status: 'IN_SEQUENCING',
      sampleType: 'SALIVA',
    },
    {
      statusDate: '2022-04-10T00:00:00Z',
      orderId: '123484',
      status: 'IN_SEQUENCING',
      sampleType: 'BLOOD',
    },

    {
      statusDate: '2022-04-01T00:00:00Z',
      orderId: '12345',
      status: 'RECEIVED',
      sampleType: 'BLOOD',
    },
    {
      statusDate: '2022-04-01T00:00:00Z',
      orderId: '123456',
      status: 'RECEIVED',
      sampleType: 'SALIVA',
    },
    {
      statusDate: '2022-04-01T00:00:00Z',
      orderId: '123457',
      status: 'IN_SEQUENCING',
      sampleType: 'SALIVA',
    },
    {
      statusDate: '2022-04-02T00:00:00Z',
      orderId: '123458',
      status: 'VALID',
      sampleType: 'BLOOD',
    },
    {
      statusDate: '2022-04-02T00:00:00Z',
      orderId: '123459',
      status: 'VALID',
      sampleType: 'SALIVA',
    },
    {
      statusDate: '2022-04-03T00:00:00Z',
      orderId: '123460',
      status: 'RECOLLECT',
      sampleType: 'BLOOD',
      failureReason: 'Failure Reason Example',
    },
    {
      statusDate: '2022-04-03T00:00:00Z',
      orderId: '123461',
      status: 'AWAITING',
      sampleType: 'BLOOD',
    },
    {
      statusDate: '2022-04-03T00:00:00Z',
      orderId: '123462',
      status: 'AWAITING',
      sampleType: 'BLOOD',
    },
    {
      statusDate: '2022-04-04T00:00:00Z',
      orderId: '123463',
      status: 'VALID',
      sampleType: 'BLOOD',
    },
    {
      statusDate: '2022-04-04T00:00:00Z',
      orderId: '123464',
      status: 'VALID',
      sampleType: 'BLOOD',
    },
    {
      statusDate: '2022-04-05T00:00:00Z',
      orderId: '123465',
      status: 'RECOLLECT',
      sampleType: 'BLOOD',
      failureReason: 'Failure Reason Example',
    },
    {
      statusDate: '2022-04-10T00:00:00Z',
      orderId: '123466',
      status: 'IN_SEQUENCING',
      sampleType: 'BLOOD',
    },
    {
      statusDate: '2022-04-10T00:00:00Z',
      orderId: '123467',
      status: 'IN_SEQUENCING',
      sampleType: 'BLOOD',
    },
    {
      statusDate: '2022-04-10T00:00:00Z',
      orderId: '123468',
      status: 'IN_SEQUENCING',
      sampleType: 'SALIVA',
    },
    {
      statusDate: '2022-04-10T00:00:00Z',
      orderId: '123469',
      status: 'IN_SEQUENCING',
      sampleType: 'BLOOD',
    },
    {
      statusDate: '2022-04-01T00:00:00Z',
      orderId: '123470',
      status: 'RECEIVED',
      sampleType: 'BLOOD',
    },
    {
      statusDate: '2022-04-01T00:00:00Z',
      orderId: '123471',
      status: 'RECEIVED',
      sampleType: 'SALIVA',
    },
    {
      statusDate: '2022-04-01T00:00:00Z',
      orderId: '123472',
      status: 'IN_SEQUENCING',
      sampleType: 'SALIVA',
    },
    {
      statusDate: '2022-04-02T00:00:00Z',
      orderId: '123473',
      status: 'VALID',
      sampleType: 'BLOOD',
    },
    {
      statusDate: '2022-04-02T00:00:00Z',
      orderId: '123474',
      status: 'VALID',
      sampleType: 'SALIVA',
    },
    {
      statusDate: '2022-04-03T00:00:00Z',
      orderId: '123475',
      status: 'RECOLLECT',
      sampleType: 'BLOOD',
      failureReason: 'Failure Reason Example',
    },
    {
      statusDate: '2022-04-03T00:00:00Z',
      orderId: '123476',
      status: 'AWAITING',
      sampleType: 'BLOOD',
    },
    {
      statusDate: '2022-04-03T00:00:00Z',
      orderId: '123477',
      status: 'AWAITING',
      sampleType: 'BLOOD',
    },
    {
      statusDate: '2022-04-04T00:00:00Z',
      orderId: '123478',
      status: 'VALID',
      sampleType: 'BLOOD',
    },
    {
      statusDate: '2022-04-04T00:00:00Z',
      orderId: '123479',
      status: 'VALID',
      sampleType: 'BLOOD',
    },
    {
      statusDate: '2022-04-05T00:00:00Z',
      orderId: '123480',
      status: 'RECOLLECT',
      sampleType: 'BLOOD',
      failureReason: 'Failure Reason Example',
    },
    {
      statusDate: '2022-04-10T00:00:00Z',
      orderId: '123481',
      status: 'IN_SEQUENCING',
      sampleType: 'BLOOD',
    },
    {
      statusDate: '2022-04-10T00:00:00Z',
      orderId: '123482',
      status: 'IN_SEQUENCING',
      sampleType: 'BLOOD',
    },
    {
      statusDate: '2022-04-10T00:00:00Z',
      orderId: '123483',
      status: 'IN_SEQUENCING',
      sampleType: 'SALIVA',
    },
    {
      statusDate: '2022-04-10T00:00:00Z',
      orderId: '123484',
      status: 'IN_SEQUENCING',
      sampleType: 'BLOOD',
    },

    {
      statusDate: '2022-04-01T00:00:00Z',
      orderId: '12345',
      status: 'RECEIVED',
      sampleType: 'BLOOD',
    },
    {
      statusDate: '2022-04-01T00:00:00Z',
      orderId: '123456',
      status: 'RECEIVED',
      sampleType: 'SALIVA',
    },
    {
      statusDate: '2022-04-01T00:00:00Z',
      orderId: '123457',
      status: 'IN_SEQUENCING',
      sampleType: 'SALIVA',
    },
    {
      statusDate: '2022-04-02T00:00:00Z',
      orderId: '123458',
      status: 'VALID',
      sampleType: 'BLOOD',
    },
    {
      statusDate: '2022-04-02T00:00:00Z',
      orderId: '123459',
      status: 'VALID',
      sampleType: 'SALIVA',
    },
    {
      statusDate: '2022-04-03T00:00:00Z',
      orderId: '123460',
      status: 'RECOLLECT',
      sampleType: 'BLOOD',
      failureReason: 'Failure Reason Example',
    },
    {
      statusDate: '2022-04-03T00:00:00Z',
      orderId: '123461',
      status: 'AWAITING',
      sampleType: 'BLOOD',
    },
    {
      statusDate: '2022-04-03T00:00:00Z',
      orderId: '123462',
      status: 'AWAITING',
      sampleType: 'BLOOD',
    },
    {
      statusDate: '2022-04-04T00:00:00Z',
      orderId: '123463',
      status: 'VALID',
      sampleType: 'BLOOD',
    },
    {
      statusDate: '2022-04-04T00:00:00Z',
      orderId: '123464',
      status: 'VALID',
      sampleType: 'BLOOD',
    },
    {
      statusDate: '2022-04-05T00:00:00Z',
      orderId: '123465',
      status: 'RECOLLECT',
      sampleType: 'BLOOD',
      failureReason: 'Failure Reason Example',
    },
    {
      statusDate: '2022-04-10T00:00:00Z',
      orderId: '123466',
      status: 'IN_SEQUENCING',
      sampleType: 'BLOOD',
    },
    {
      statusDate: '2022-04-10T00:00:00Z',
      orderId: '123467',
      status: 'IN_SEQUENCING',
      sampleType: 'BLOOD',
    },
    {
      statusDate: '2022-04-10T00:00:00Z',
      orderId: '123468',
      status: 'IN_SEQUENCING',
      sampleType: 'SALIVA',
    },
    {
      statusDate: '2022-04-10T00:00:00Z',
      orderId: '123469',
      status: 'IN_SEQUENCING',
      sampleType: 'BLOOD',
    },
    {
      statusDate: '2022-04-01T00:00:00Z',
      orderId: '123470',
      status: 'RECEIVED',
      sampleType: 'BLOOD',
    },
    {
      statusDate: '2022-04-01T00:00:00Z',
      orderId: '123471',
      status: 'RECEIVED',
      sampleType: 'SALIVA',
    },
    {
      statusDate: '2022-04-01T00:00:00Z',
      orderId: '123472',
      status: 'IN_SEQUENCING',
      sampleType: 'SALIVA',
    },
    {
      statusDate: '2022-04-02T00:00:00Z',
      orderId: '123473',
      status: 'VALID',
      sampleType: 'BLOOD',
    },
    {
      statusDate: '2022-04-02T00:00:00Z',
      orderId: '123474',
      status: 'VALID',
      sampleType: 'SALIVA',
    },
    {
      statusDate: '2022-04-03T00:00:00Z',
      orderId: '123475',
      status: 'RECOLLECT',
      sampleType: 'BLOOD',
      failureReason: 'Failure Reason Example',
    },
    {
      statusDate: '2022-04-03T00:00:00Z',
      orderId: '123476',
      status: 'AWAITING',
      sampleType: 'BLOOD',
    },
    {
      statusDate: '2022-04-03T00:00:00Z',
      orderId: '123477',
      status: 'AWAITING',
      sampleType: 'BLOOD',
    },
    {
      statusDate: '2022-04-04T00:00:00Z',
      orderId: '123478',
      status: 'VALID',
      sampleType: 'BLOOD',
    },
    {
      statusDate: '2022-04-04T00:00:00Z',
      orderId: '123479',
      status: 'VALID',
      sampleType: 'BLOOD',
    },
  ],
};

export const MOCK_GOALS: EditGoal = {
  baseline: 2000,
  endDate: '2024-12-31T00:00:00Z',
  goals: [
    {
      endDate: '2021-12-31T00:00:00Z',
      startDate: '2021-01-01T00:00:00Z',
      target: 15000,
      value: 4000,
    },
    {
      endDate: '2022-12-31T00:00:00Z',
      startDate: '2022-01-01T00:00:00Z',
      target: 25000,
      value: 1000,
    },
    {
      endDate: '2023-12-31T00:00:00Z',
      startDate: '2023-01-01T00:00:00Z',
      target: 30000,
      value: 5000,
    },
    {
      endDate: '2024-12-31T00:00:00Z',
      startDate: '2024-01-01T00:00:00Z',
      target: 30000,
      value: 0,
    },
  ],
  startDate: '2021-01-01T00:00:00Z',
};

export const MOCK_FAILURE_REASON_RESPONSE: KitFailureReasonResponse = {
  kitId: 'kit123',
  event: 'event test',
  source: 'source test',
  failureReason: 'failure reason test',
};

export const MOCK_SEQUENCED_SAMPLES_RESPONSE: SequencedSamples = {
  stats: {
    percentChanges: [
      {
        collectionLocation: SampleCollectionLocation.IN_PERSON,
        value: 1.5,
      },
      {
        collectionLocation: SampleCollectionLocation.AT_HOME,
        value: -1.2,
      },
    ],
  },
  series: [
    {
      collectionLocation: SampleCollectionLocation.IN_PERSON,
      status: SequencedSampleSerieStatus.SEQUENCING_COMPLETE,
      type: SampleSerieType.SALIVA,
      groupValue: '2023-06-10T00:00:00Z',
      value: 50,
    },
    {
      collectionLocation: SampleCollectionLocation.IN_PERSON,
      status: SequencedSampleSerieStatus.SEQUENCING_COMPLETE,
      type: SampleSerieType.BLOOD,
      groupValue: '2023-06-10T00:00:00Z',
      value: 7,
    },
    {
      collectionLocation: SampleCollectionLocation.IN_PERSON,
      status: SequencedSampleSerieStatus.RECOLLECT,
      type: SampleSerieType.SALIVA,
      groupValue: '2023-06-10T00:00:00Z',
      value: 4,
    },
    {
      collectionLocation: SampleCollectionLocation.IN_PERSON,
      status: SequencedSampleSerieStatus.SEQUENCING_COMPLETE,
      type: SampleSerieType.SALIVA,
      groupValue: '2023-06-13T00:00:00Z',
      value: 14,
    },
    {
      collectionLocation: SampleCollectionLocation.IN_PERSON,
      status: SequencedSampleSerieStatus.SEQUENCING_COMPLETE,
      type: SampleSerieType.SALIVA,
      groupValue: '2023-06-14T00:00:00Z',
      value: 30,
    },
    {
      collectionLocation: SampleCollectionLocation.IN_PERSON,
      status: SequencedSampleSerieStatus.SEQUENCING_COMPLETE,
      type: SampleSerieType.BLOOD,
      groupValue: '2023-06-16T00:00:00Z',
      value: 3,
    },
    {
      collectionLocation: SampleCollectionLocation.AT_HOME,
      status: SequencedSampleSerieStatus.SEQUENCING_COMPLETE,
      type: SampleSerieType.SALIVA,
      groupValue: '2023-06-10T00:00:00Z',
      value: 28,
    },
    {
      collectionLocation: SampleCollectionLocation.AT_HOME,
      status: SequencedSampleSerieStatus.SEQUENCING_COMPLETE,
      type: SampleSerieType.BLOOD,
      groupValue: '2023-06-10T00:00:00Z',
      value: 10,
    },
    {
      collectionLocation: SampleCollectionLocation.AT_HOME,
      status: SequencedSampleSerieStatus.RECOLLECT,
      type: SampleSerieType.SALIVA,
      groupValue: '2023-06-10T00:00:00Z',
      value: 5,
    },
    {
      collectionLocation: SampleCollectionLocation.AT_HOME,
      status: SequencedSampleSerieStatus.RESULTS_DELIVERED,
      type: SampleSerieType.SALIVA,
      groupValue: '2023-06-10T00:00:00Z',
      value: 2,
    },
    {
      collectionLocation: SampleCollectionLocation.AT_HOME,
      status: SequencedSampleSerieStatus.SEQUENCING_COMPLETE,
      type: SampleSerieType.SALIVA,
      groupValue: '2023-06-11T00:00:00Z',
      value: 19,
    },
    {
      collectionLocation: SampleCollectionLocation.AT_HOME,
      status: SequencedSampleSerieStatus.SEQUENCING_COMPLETE,
      type: SampleSerieType.SALIVA,
      groupValue: '2023-06-14T00:00:00Z',
      value: 30,
    },
  ],
};

export const MOCK_RESULTS_DELIVERED_RESPONSE: SequencedSamples = {
  stats: {
    percentChanges: [
      {
        collectionLocation: SampleCollectionLocation.IN_PERSON,
        value: 1.5,
      },
      {
        collectionLocation: SampleCollectionLocation.AT_HOME,
        value: -1.2,
      },
    ],
  },
  series: [
    {
      collectionLocation: SampleCollectionLocation.IN_PERSON,
      status: SequencedSampleSerieStatus.RESULTS_DELIVERED,
      type: SampleSerieType.SALIVA,
      groupValue: '2023-06-10T00:00:00Z',
      value: 50,
    },
    {
      collectionLocation: SampleCollectionLocation.IN_PERSON,
      status: SequencedSampleSerieStatus.RESULTS_DELIVERED,
      type: SampleSerieType.BLOOD,
      groupValue: '2023-06-11T00:00:00Z',
      value: 7,
    },
  ],
};

export const MOCK_SEQUENCED_SAMPLES_FORMATTED = {
  total: 202,
  IN_PERSON: {
    total: 108,
    totalValid: 104,
    totalRecollect: 4,
    SALIVA: {
      total: 98,
      RECOLLECT: {
        total: 4,
        percentage: 4.081632653061225,
      },
      RESULTS_DELIVERED: {
        total: 0,
        percentage: 0,
      },
      SEQUENCING_COMPLETE: {
        total: 94,
        percentage: 95.91836734693877,
      },
      VALID: {
        percentage: 95.91836734693877,
        total: 94,
      },
      percentage: 90.74074074074075,
    },
    BLOOD: {
      total: 10,
      RECOLLECT: {
        total: 0,
        percentage: 0,
      },
      RESULTS_DELIVERED: {
        total: 0,
        percentage: 0,
      },
      SEQUENCING_COMPLETE: {
        total: 10,
        percentage: 100,
      },
      VALID: {
        percentage: 100,
        total: 10,
      },
      percentage: 9.25925925925926,
    },
    BUCCAL_SWAB: {
      total: 0,
      RECOLLECT: {
        total: 0,
        percentage: 0,
      },
      RESULTS_DELIVERED: {
        total: 0,
        percentage: 0,
      },
      SEQUENCING_COMPLETE: {
        total: 0,
        percentage: 0,
      },
      VALID: {
        percentage: 0,
        total: 0,
      },
      percentage: 0,
    },
    percentage: 53.46534653465347,
  },
  AT_HOME: {
    total: 94,
    totalValid: 89,
    totalRecollect: 5,
    SALIVA: {
      total: 84,
      RECOLLECT: {
        total: 5,
        percentage: 5.952380952380952,
      },
      RESULTS_DELIVERED: {
        total: 2,
        percentage: 2.380952380952381,
      },
      SEQUENCING_COMPLETE: {
        total: 77,
        percentage: 91.66666666666666,
      },
      VALID: {
        percentage: 94.04761904761905,
        total: 79,
      },
      percentage: 89.36170212765957,
    },
    BLOOD: {
      total: 10,
      RECOLLECT: {
        total: 0,
        percentage: 0,
      },
      RESULTS_DELIVERED: {
        total: 0,
        percentage: 0,
      },
      SEQUENCING_COMPLETE: {
        total: 10,
        percentage: 100,
      },
      VALID: {
        percentage: 100,
        total: 10,
      },
      percentage: 10.638297872340425,
    },
    BUCCAL_SWAB: {
      total: 0,
      RECOLLECT: {
        total: 0,
        percentage: 0,
      },
      RESULTS_DELIVERED: {
        total: 0,
        percentage: 0,
      },
      SEQUENCING_COMPLETE: {
        total: 0,
        percentage: 0,
      },
      VALID: {
        percentage: 0,
        total: 0,
      },
      percentage: 0,
    },
    percentage: 46.53465346534654,
  },
  REUSE: {
    total: 0,
    totalValid: 0,
    totalRecollect: 0,
    SALIVA: {
      total: 0,
      RECOLLECT: { total: 0, percentage: 0 },
      RESULTS_DELIVERED: { total: 0, percentage: 0 },
      SEQUENCING_COMPLETE: { total: 0, percentage: 0 },
      VALID: { percentage: 0, total: 0 },
      percentage: 0,
    },
    BLOOD: {
      total: 0,
      RECOLLECT: { total: 0, percentage: 0 },
      RESULTS_DELIVERED: { total: 0, percentage: 0 },
      SEQUENCING_COMPLETE: { total: 0, percentage: 0 },
      VALID: { percentage: 0, total: 0 },
      percentage: 0,
    },
    BUCCAL_SWAB: {
      total: 0,
      RECOLLECT: { total: 0, percentage: 0 },
      RESULTS_DELIVERED: { total: 0, percentage: 0 },
      SEQUENCING_COMPLETE: { total: 0, percentage: 0 },
      VALID: { percentage: 0, total: 0 },
      percentage: 0,
    },
    percentage: 0,
  },
  NOT_AVAILABLE: {
    total: 0,
    totalValid: 0,
    totalRecollect: 0,
    SALIVA: {
      total: 0,
      RECOLLECT: { total: 0, percentage: 0 },
      RESULTS_DELIVERED: { total: 0, percentage: 0 },
      SEQUENCING_COMPLETE: { total: 0, percentage: 0 },
      VALID: { percentage: 0, total: 0 },
      percentage: 0,
    },
    BLOOD: {
      total: 0,
      RECOLLECT: { total: 0, percentage: 0 },
      RESULTS_DELIVERED: { total: 0, percentage: 0 },
      SEQUENCING_COMPLETE: { total: 0, percentage: 0 },
      VALID: { percentage: 0, total: 0 },
      percentage: 0,
    },
    BUCCAL_SWAB: {
      total: 0,
      RECOLLECT: { total: 0, percentage: 0 },
      RESULTS_DELIVERED: { total: 0, percentage: 0 },
      SEQUENCING_COMPLETE: { total: 0, percentage: 0 },
      VALID: { percentage: 0, total: 0 },
      percentage: 0,
    },
    percentage: 0,
  },
};

export const MOCK_RECEIVED_SAMPLES_RESPONSE: ReceivedSamples = {
  stats: {
    percentChanges: [
      {
        collectionLocation: SampleCollectionLocation.IN_PERSON,
        value: 1.5,
      },
      {
        collectionLocation: SampleCollectionLocation.AT_HOME,
        value: 1.5,
      },
    ],
  },
  series: [
    {
      collectionLocation: SampleCollectionLocation.IN_PERSON,
      type: SampleSerieType.BLOOD,
      groupValue: '2023-06-10T00:00:00Z',
      value: 39,
      status: ReceivedSampleSerieStatus.RECEIVED,
    },
    {
      collectionLocation: SampleCollectionLocation.IN_PERSON,
      type: SampleSerieType.SALIVA,
      groupValue: '2023-06-10T00:00:00Z',
      value: 5,
      status: ReceivedSampleSerieStatus.RECEIVED,
    },
    {
      collectionLocation: SampleCollectionLocation.IN_PERSON,
      type: SampleSerieType.BLOOD,
      groupValue: '2023-06-12T00:00:00Z',
      value: 50,
      status: ReceivedSampleSerieStatus.RECEIVED,
    },
    {
      collectionLocation: SampleCollectionLocation.IN_PERSON,
      type: SampleSerieType.BLOOD,
      groupValue: '2023-06-14T00:00:00Z',
      value: 25,
      status: ReceivedSampleSerieStatus.IN_SEQUENCING,
    },
    {
      collectionLocation: SampleCollectionLocation.IN_PERSON,
      type: SampleSerieType.BLOOD,
      groupValue: '2023-06-15T00:00:00Z',
      value: 5,
      status: ReceivedSampleSerieStatus.IN_SEQUENCING,
    },
    {
      collectionLocation: SampleCollectionLocation.AT_HOME,
      type: SampleSerieType.SALIVA,
      groupValue: '2023-06-10T00:00:00Z',
      value: 44,
      status: ReceivedSampleSerieStatus.SEQUENCING_COMPLETE,
    },
    {
      collectionLocation: SampleCollectionLocation.AT_HOME,
      type: SampleSerieType.SALIVA,
      groupValue: '2023-06-13T00:00:00Z',
      value: 43,
      status: ReceivedSampleSerieStatus.SEQUENCING_COMPLETE,
    },
    {
      collectionLocation: SampleCollectionLocation.AT_HOME,
      type: SampleSerieType.SALIVA,
      groupValue: '2023-06-16T00:00:00Z',
      value: 40,
      status: ReceivedSampleSerieStatus.RESULTS_DELIVERED,
    },
  ],
};

export const MOCK_RECEIVED_SAMPLES_FORMATTED = {
  total: 251,
  IN_PERSON: {
    total: 124,
    BLOOD: {
      total: 119,
      percentage: 95.96774193548387,
    },
    SALIVA: {
      total: 5,
      percentage: 4.032258064516129,
    },
    BUCCAL_SWAB: {
      total: 0,
      percentage: 0,
    },
    percentage: 49.40239043824701,
  },
  AT_HOME: {
    total: 127,
    BLOOD: {
      total: 0,
      percentage: 0,
    },
    SALIVA: {
      total: 127,
      percentage: 100,
    },
    BUCCAL_SWAB: {
      total: 0,
      percentage: 0,
    },
    percentage: 50.59760956175299,
  },
  REUSE: {
    total: 0,
    BLOOD: { total: 0, percentage: 0 },
    SALIVA: { total: 0, percentage: 0 },
    BUCCAL_SWAB: { total: 0, percentage: 0 },
    percentage: 0,
  },
  NOT_AVAILABLE: {
    total: 0,
    BLOOD: { total: 0, percentage: 0 },
    SALIVA: { total: 0, percentage: 0 },
    BUCCAL_SWAB: { total: 0, percentage: 0 },
    percentage: 0,
  },
};

export const MOCK_AWAITING_SAMPLES_RESPONSE = [
  {
    collectionLocation: SampleCollectionLocation.IN_PERSON,
    value: 129,
  },
  {
    collectionLocation: SampleCollectionLocation.AT_HOME,
    value: 72,
  },
];

export const MOCK_AWAITING_SAMPLES_FORMATTED = {
  total: 201,
  IN_PERSON: {
    total: 129,
    percentage: 64.17910447761194,
  },
  AT_HOME: {
    total: 72,
    percentage: 35.82089552238806,
  },
  REUSE: {
    total: 0,
    percentage: 0,
  },
  NOT_AVAILABLE: {
    total: 0,
    percentage: 0,
  },
};

export const MOCK_FORMATTED_BAR_CHART: SingleValueBarFormat[] = [
  {
    groupValue: 'Jul 2021',
    value: 500,
  },
  {
    groupValue: 'Aug 2021',
    value: 1400,
  },
  {
    groupValue: 'Sep 2021',
    value: 2300,
  },
  {
    groupValue: 'Oct 2021',
    value: 1800,
  },
  {
    groupValue: 'Nov 2021',
    value: 200,
  },
  {
    groupValue: 'Dec 2021',
    value: 2200,
  },
  {
    groupValue: 'Jan 2022',
    value: 600,
  },
  {
    groupValue: 'Feb 2022',
    value: 1500,
  },
  {
    groupValue: 'Mar 2022',
    value: 700,
  },
  {
    groupValue: 'Apr 2022',
    value: 1600,
  },
  {
    groupValue: 'May 2022',
    value: 1100,
  },
  {
    groupValue: 'Jun 2022',
    value: 2000,
  },
  {
    groupValue: 'Jul 2022',
    value: 1500,
  },
  {
    groupValue: 'Aug 2022',
    value: 2400,
  },
  {
    groupValue: 'Sep 2022',
    value: 800,
  },
  {
    groupValue: 'Oct 2022',
    value: 300,
  },
  {
    groupValue: 'Nov 2022',
    value: 1200,
  },
  {
    groupValue: 'Dec 2022',
    value: 700,
  },
  {
    groupValue: 'Jan 2023',
    value: 1600,
  },
  {
    groupValue: 'Feb 2023',
    value: 2500,
  },
  {
    groupValue: 'Mar 2023',
    value: 1700,
  },
  {
    groupValue: 'Apr 2023',
    value: 100,
  },
  {
    groupValue: 'May 2023',
    value: 2100,
  },
  {
    groupValue: 'Jun 2023',
    value: 500,
  },
  {
    groupValue: 'Jul 2023',
    value: 2500,
  },
];

export const MOCK_CDC_TIER_1_RESULTS_BREAKDOWN = {
  delivered: {
    total: 2400,
    negative: 2304,
    positive: 96,
    positivePercentage: 4,
    negativePercentage: 96,
  },
  ls: {
    total: 35,
    percentage: 32.71,
    totalPercentage: 1.46,
  },
  fh: {
    total: 24,
    percentage: 22.43,
    totalPercentage: 1,
  },
  hboc: {
    total: 48,
    percentage: 44.86,
    totalPercentage: 2,
  },
};

export const MOCK_BASIC_BAR_CHART = {
  baseline: 380,
  series: [
    {
      converted: 50,
      groupValue: '2024-02-01T16:00:00-08:00',
      value: 100,
    },
    {
      converted: 15,
      groupValue: '2024-02-02T16:00:00-08:00',
      value: 30,
    },
    {
      converted: 200,
      groupValue: '2024-02-03T16:00:00-08:00',
      value: 400,
    },
    {
      converted: 2,
      groupValue: '2024-02-04T16:00:00-08:00',
      value: 10,
    },
    {
      converted: 370,
      groupValue: '2024-02-05T16:00:00-08:00',
      value: 500,
    },
    {
      converted: 40,
      groupValue: '2024-02-06T16:00:00-08:00',
      value: 70,
    },
    {
      converted: 5,
      groupValue: '2024-02-07T16:00:00-08:00',
      value: 10,
    },
    {
      converted: 30,
      groupValue: '2024-02-08T16:00:00-08:00',
      value: 30,
    },
    {
      converted: 35,
      groupValue: '2024-02-09T16:00:00-08:00',
      value: 40,
    },
    {
      converted: 100,
      groupValue: '2024-02-10T16:00:00-08:00',
      value: 140,
    },
    {
      converted: 50,
      groupValue: '2024-02-11T16:00:00-08:00',
      value: 50,
    },
    {
      converted: 45,
      groupValue: '2024-02-12T16:00:00-08:00',
      value: 50,
    },
    {
      converted: 30,
      groupValue: '2024-02-13T16:00:00-08:00',
      value: 80,
    },
    {
      converted: 20,
      groupValue: '2024-02-14T16:00:00-08:00',
      value: 50,
    },
    {
      converted: 5,
      groupValue: '2024-02-15T16:00:00-08:00',
      value: 30,
    },
    {
      converted: 15,
      groupValue: '2024-02-16T16:00:00-08:00',
      value: 90,
    },
    {
      converted: 320,
      groupValue: '2024-02-17T16:00:00-08:00',
      value: 400,
    },
    {
      converted: 25,
      groupValue: '2024-02-18T16:00:00-08:00',
      value: 30,
    },
    {
      converted: 20,
      groupValue: '2024-02-19T16:00:00-08:00',
      value: 70,
    },
    {
      converted: 5,
      groupValue: '2024-02-20T16:00:00-08:00',
      value: 90,
    },
    {
      converted: 20,
      groupValue: '2024-02-21T16:00:00-08:00',
      value: 30,
    },
    {
      converted: 0,
      groupValue: '2024-02-22T16:00:00-08:00',
      value: 10,
    },
    {
      converted: 15,
      groupValue: '2024-02-23T16:00:00-08:00',
      value: 20,
    },
    {
      converted: 25,
      groupValue: '2024-02-24T16:00:00-08:00',
      value: 80,
    },
    {
      converted: 30,
      groupValue: '2024-02-25T16:00:00-08:00',
      value: 40,
    },
    {
      converted: 50,
      groupValue: '2024-02-26T16:00:00-08:00',
      value: 50,
    },
    {
      converted: 25,
      groupValue: '2024-02-27T16:00:00-08:00',
      value: 40,
    },
    {
      converted: 10,
      groupValue: '2024-02-28T16:00:00-08:00',
      value: 280,
    },
    {
      converted: 10,
      groupValue: '2024-02-29T16:00:00-08:00',
      value: 280,
    },
    {
      converted: 5,
      groupValue: '2024-03-01T16:00:00-08:00',
      value: 10,
    },
    {
      converted: 10,
      groupValue: '2024-03-02T16:00:00-08:00',
      value: 90,
    },
    {
      converted: 45,
      groupValue: '2024-03-04T16:00:00-08:00',
      value: 50,
    },
    {
      converted: 30,
      groupValue: '2024-03-05T16:00:00-08:00',
      value: 60,
    },
    {
      converted: 35,
      groupValue: '2024-03-06T16:00:00-08:00',
      value: 40,
    },
    {
      converted: 100,
      groupValue: '2024-03-07T16:00:00-08:00',
      value: 110,
    },
    {
      converted: 25,
      groupValue: '2024-03-08T16:00:00-08:00',
      value: 90,
    },
    {
      converted: 50,
      groupValue: '2024-03-09T16:00:00-08:00',
      value: 110,
    },
    {
      converted: 20,
      groupValue: '2024-03-10T16:00:00-08:00',
      value: 50,
    },
    {
      converted: 35,
      groupValue: '2024-03-11T16:00:00-08:00',
      value: 130,
    },
    {
      converted: 75,
      groupValue: '2024-03-12T16:00:00-08:00',
      value: 200,
    },
    {
      converted: 30,
      groupValue: '2024-03-13T16:00:00-08:00',
      value: 30,
    },
    {
      converted: 30,
      groupValue: '2024-03-14T16:00:00-08:00',
      value: 40,
    },
    {
      converted: 40,
      groupValue: '2024-03-15T16:00:00-08:00',
      value: 60,
    },
    {
      converted: 30,
      groupValue: '2024-03-16T16:00:00-08:00',
      value: 80,
    },
    {
      converted: 25,
      groupValue: '2024-03-17T16:00:00-08:00',
      value: 30,
    },
    {
      converted: 10,
      groupValue: '2024-03-18T16:00:00-08:00',
      value: 50,
    },
    {
      converted: 30,
      groupValue: '2024-03-19T16:00:00-08:00',
      value: 100,
    },
    {
      converted: 20,
      groupValue: '2024-03-20T16:00:00-08:00',
      value: 40,
    },
    {
      converted: 65,
      groupValue: '2024-03-21T16:00:00-08:00',
      value: 90,
    },
    {
      converted: 30,
      groupValue: '2024-03-22T16:00:00-08:00',
      value: 70,
    },
    {
      converted: 40,
      groupValue: '2024-03-23T16:00:00-08:00',
      value: 200,
    },
    {
      converted: 45,
      groupValue: '2024-03-24T16:00:00-08:00',
      value: 50,
    },
    {
      converted: 35,
      groupValue: '2024-03-25T16:00:00-08:00',
      value: 40,
    },
    {
      converted: 20,
      groupValue: '2024-03-26T16:00:00-08:00',
      value: 70,
    },
    {
      converted: 35,
      groupValue: '2024-03-27T16:00:00-08:00',
      value: 100,
    },
  ],
};

export const MOCK_WEEKLY_BAR_CHART = [
  {
    groupValue: 'Week 1 Jul 1 - Jul 7',
    value: 590,
  },
  {
    groupValue: 'Week 2 Jul 8 - Jul 15',
    value: 430,
  },
  {
    groupValue: 'Week 3 Jul 16 - Jul 24',
    value: 740,
  },
  {
    groupValue: 'Week 4 Jul 25 - Jul 30',
    value: 460,
  },
];

export const MOCK_MONTHLY_BAR_CHART = [
  {
    converted: 0,
    groupValue: 'Aug 2024',
    value: 0,
    dates: [
      '2024-08-01T03:00:00.000Z', // beginning of the month
      '2024-08-31T03:00:00.000Z', // end of the month
    ],
  },
];

export const MOCK_DAILY_BAR_CHART = [
  {
    converted: 200,
    groupValue: 'Sat 3',
    value: 400,
    dates: [
      '2024-02-03T16:00:00-08:00', // current date
    ],
    convertedPercentage: 50,
  },
];

export const MOCK_PARTNER_CONSENTED_PARTICIPANTS_DATA: PartnerConsentedParticipantsData = {
  overView: {
    totalConsented: 3035,
    totalConversionRate: 99,
    goalLine: 384,
    consentedGoal: 1882,
  },
  groupData: {
    stats: {
      statsData: [
        {
          label: 'consented',
          value: 40,
          percentChange: 32,
        },
        {
          label: 'conversionrate',
          value: 40,
          percentChange: 32,
        },
      ],
    },
    dateSeries: [
      {
        groupValue: '2024-01-01T00:00:00Z',
        consentValue: 2300,
        conversionValue: 19,
      },
      {
        groupValue: '2024-01-08T00:00:00Z',
        consentValue: 2100,
        conversionValue: 6,
      },
      {
        groupValue: '2024-01-15T00:00:00Z',
        consentValue: 1900,
        conversionValue: 28,
      },
      {
        groupValue: '2024-01-22T00:00:00Z',
        consentValue: 1700,
        conversionValue: 86,
      },
      {
        groupValue: '2024-01-29T00:00:00Z',
        consentValue: 1500,
        conversionValue: 10,
      },
    ],
  },
};

export const MOCK_HHC_CONSENTED_PARTICIPANTS_DATA: HhcParticipantData = {
  overView: {
    totalConsented: 3035,
    totalConversionRate: 99,
    goalLine: 384,
    consentedGoal: 1882,
  },
  groupData: {
    stats: {
      statsData: [
        {
          label: 'consented',
          value: 40,
          percentChange: 32,
        },
        {
          label: 'conversionrate',
          value: 40,
          percentChange: 32,
        },
      ],
    },
    dateSeries: [
      {
        groupValue: '2024-01-01T00:00:00Z',
        consentValue: 2300,
        conversionValue: 19,
      },
      {
        groupValue: '2024-01-08T00:00:00Z',
        consentValue: 2100,
        conversionValue: 6,
      },
      {
        groupValue: '2024-01-15T00:00:00Z',
        consentValue: 1900,
        conversionValue: 28,
      },
      {
        groupValue: '2024-01-22T00:00:00Z',
        consentValue: 1700,
        conversionValue: 86,
      },
      {
        groupValue: '2024-01-29T00:00:00Z',
        consentValue: 1500,
        conversionValue: 10,
      },
    ],
    locationSeries: [],
  },
};

export const MOCK_CONSENT_STATUS: ConsentStatus[] = [
  {
    status: 'Email Sent',
    total: 1461,
    isPositive: true,
  },
  {
    status: 'Email Clicked',
    total: 291,
    isPositive: true,
  },
  {
    status: 'Eligible',
    total: 1388,
    isPositive: true,
  },
  {
    status: 'Ineligible',
    total: 156,
    isPositive: true,
  },
  {
    status: 'Declined',
    total: 2651,
    isPositive: false,
  },
  {
    status: 'Consented',
    total: 24102,
    isPositive: false,
  },
];
